import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsVelomobileNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.73 7.31l2.85-1.58a2.024 2.024 0 001.89 1.39c.087-.002.174-.008.26-.02l2.51-.32 2.93-.18a5.209 5.209 0 013.06.79.553.553 0 01.06.91c-.59.478-1.32.749-2.08.77a1.951 1.951 0 00-1.71-1 2.013 2.013 0 00-1.74 1H2.4l-.45-1.31-.89.5.63 1.81h.824a1.992 1.992 0 103.984 0h2a2 2 0 003.99-.01v-.01a4.473 4.473 0 002.42-.96 1.549 1.549 0 00.372-2.011 1.6 1.6 0 00-.582-.579 6.2 6.2 0 00-3.59-.9l-2.64.16-.11-.21a2.829 2.829 0 00-2.49-1.5 5.066 5.066 0 00-2.44.63L.39 6.33l.34.98zm3.776 3.744a.993.993 0 01-.99-.984H5.5a.993.993 0 01-.994.984zm5.994 0a.99.99 0 11.99-.99.994.994 0 01-.99.986v.004zm-4.63-6a1.761 1.761 0 011.51.83L5.6 6.11a.965.965 0 01-.77-.24.982.982 0 01-.33-.57 3.739 3.739 0 011.37-.25v.004z"
        fill=""
      />
    </svg>
  )
);
SvgSportsVelomobileNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsVelomobileNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsVelomobileNormalXsmall;
